import { NetworkCheckWrapper } from "@/hofs/checkError/withCheckNetworkError";

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;

  return <NetworkCheckWrapper>{children}</NetworkCheckWrapper>;
};
